export default __webpack_public_path__ + "static/media/Play Dashes_1@2x.610a554a.png";